import React from 'react';
import { useTranslation } from 'react-i18next';

const FormulaUpdateConfirmation = ({
  pricing, currentPrice, newPrice, effectiveDate, formatAmount,
  body, isUpdating, isDisabled, handleClose, handleConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <div className="t-fixed t-inset-0 t-z-[1000] t-bg-navy/40 t-px-4 t-flex t-items-center t-justify-center">
      <div className="t-w-full t-max-w-[500px] t-rounded-lg t-bg-white t-p-6 t-shadow-xl">
        <p className="t-text-xs t-font-bold t-uppercase t-tracking-wide t-text-quiz-teal t-m-0 t-mb-2">
          {t('QuizComparison_ConfirmEyebrow')}
        </p>
        <h2 className="t-font-serif t-text-3xl t-leading-tight t-text-navy t-m-0 t-mb-3">
          {t('QuizComparison_ConfirmTitle')}
        </h2>
        <p className="t-text-sm t-leading-relaxed t-text-g500 t-m-0 t-mb-5">
          {body || (effectiveDate
            ? t('QuizComparison_ConfirmBodyWithDate', { currentPrice, newPrice, effectiveDate })
            : t('QuizComparison_ConfirmBody', { currentPrice, newPrice }))}
        </p>
        <div className="t-rounded-lg t-border-2 t-border-quiz-teal t-bg-[#E6F2EE] t-p-4 t-mb-5">
          <span className="t-block t-text-xs t-font-bold t-uppercase t-tracking-wide t-text-quiz-teal">
            {t('QuizComparison_NewRenewalPrice')}
          </span>
          <div className="t-mt-3 t-flex t-flex-wrap t-items-baseline t-gap-x-3 t-gap-y-1">
            <del className="t-shrink-0 t-text-base t-text-navy/50">
              <span className="t-sr-only">{t('QuizComparison_CurrentPrice')}: </span>
              {formatAmount(pricing.currentPrice ?? pricing.roundedCurrentPrice, pricing.currency)}
            </del>
            <span className="t-min-w-0 t-break-words t-font-serif t-text-3xl t-leading-tight t-text-navy">
              {newPrice}
            </span>
          </div>
        </div>
        <div className="t-flex t-flex-col-reverse t-gap-3 sm:t-flex-row sm:t-justify-end">
          <button
            type="button"
            className="t-rounded-lg t-border-2 t-border-quiz-teal t-bg-white t-px-5 t-py-3 t-text-sm t-font-semibold t-text-navy"
            onClick={handleClose}
            disabled={isUpdating}
          >
            {t('QuizComparison_Cancel')}
          </button>
          <button
            type="button"
            className="t-rounded-lg t-border-2 t-border-quiz-teal t-bg-quiz-teal t-px-5 t-py-3 t-text-sm t-font-semibold t-text-white disabled:t-opacity-70"
            onClick={handleConfirm}
            disabled={isDisabled}
          >
            {isUpdating ? t('QuizComparison_Saving') : t('QuizComparison_ConfirmUpdate')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormulaUpdateConfirmation;
